import {Badge, Card, Col, Row} from "react-bootstrap";
import TableTypeText from "./TableDataTypeElements/TableTypeText";
import React, {useState, useEffect} from "react";
import TableTypeTitle from "./TableDataTypeElements/TableTypeTitle";
import TableTypeIconCount from "./TableDataTypeElements/TableTypeIconCount";
import {
    faGraduationCap,
    faSuitcase,
    faAngleRight,
    faAngleLeft,
    faAnglesRight,
    faAnglesLeft,
    faSort,
    faSortUp,
    faSortDown
} from "@fortawesome/free-solid-svg-icons";
import TableTypeDropDown from "./TableDataTypeElements/TableTypeDropDown";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import TableTypeHidden from "./TableDataTypeElements/TableTypeHidden";
import TableTypeButton from "./TableDataTypeElements/TableTypeButton";
import TableTypeDate from "./TableDataTypeElements/TableTypeDate";


export const TableDataTypes = {
    text: TableTypeText,
    title: TableTypeTitle,
    iconCount: TableTypeIconCount,
    dropDown: TableTypeDropDown,
    hidden: TableTypeHidden,
    button: TableTypeButton,
    date: TableTypeDate
};

let columnData = [
    {name: "Module ID", type: TableDataTypes.title, size: 3},
    {name: "Cases", type: TableDataTypes.iconCount,props: {icon: faSuitcase}, size: 2},
    {name: "Students", type: TableDataTypes.iconCount,props: {icon: faGraduationCap}, size: 2},
    {name: "Created on", type: TableDataTypes.text, size: 3},
    {name: "Sessions", type: TableDataTypes.dropDown,props: {items: ["1","2"]}, size: 2}
]

let pageLength = 20;

function TableList (props){
    let rowData = []

    if(props.columnData != null){
        columnData = props.columnData;
    }
    if(props.rowData != null){
        rowData = props.rowData;
    }

    const [selected, setSelected] = useState(-1);
    const [page, setPage] = useState(0);
    const [sortConfig, setSortConfig] = useState({
        key: null,
        direction: 'asc'
    });
    const [sortedData, setSortedData] = useState(rowData);

    useEffect(() => {
        let sortableData = [...rowData];
        if (sortConfig.key !== null) {
            sortableData.sort((a, b) => {
                // Get the values to compare
                const valueA = a[sortConfig.key];
                const valueB = b[sortConfig.key];
                
                // Special handling for date type columns
                if (columnData[sortConfig.key] && columnData[sortConfig.key].type === TableDataTypes.date) {
                    // Extract timestamps for comparison
                    let timestampA = 0;
                    let timestampB = 0;
                    
                    // Handle different date formats
                    if (valueA instanceof Date) {
                        timestampA = valueA.getTime();
                    } else if (typeof valueA === 'number') {
                        timestampA = valueA;
                    } else if (typeof valueA === 'string') {
                        // Try to parse as date
                        const dateA = new Date(valueA);
                        if (!isNaN(dateA.getTime())) {
                            timestampA = dateA.getTime();
                        }
                    }
                    
                    if (valueB instanceof Date) {
                        timestampB = valueB.getTime();
                    } else if (typeof valueB === 'number') {
                        timestampB = valueB;
                    } else if (typeof valueB === 'string') {
                        // Try to parse as date
                        const dateB = new Date(valueB);
                        if (!isNaN(dateB.getTime())) {
                            timestampB = dateB.getTime();
                        }
                    }
                    
                    if (timestampA < timestampB) {
                        return sortConfig.direction === 'asc' ? -1 : 1;
                    }
                    if (timestampA > timestampB) {
                        return sortConfig.direction === 'asc' ? 1 : -1;
                    }
                    return 0;
                } else {
                    // Regular comparison for non-date types
                    if (valueA < valueB) {
                        return sortConfig.direction === 'asc' ? -1 : 1;
                    }
                    if (valueA > valueB) {
                        return sortConfig.direction === 'asc' ? 1 : -1;
                    }
                    return 0;
                }
            });
        }
        setSortedData(sortableData);
    }, [rowData, sortConfig]);

    const requestSort = (index) => {
        // Skip sorting if column is hidden or not sortable
        if (columnData[index].type === TableDataTypes.hidden || columnData[index].sortable === false) {
            return;
        }
        
        // Determine sort direction
        let direction = 'asc';
        if (sortConfig.key === index && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        
        setSortConfig({ key: index, direction });
    };

    const getSortIcon = (index) => {
        if (sortConfig.key === index) {
            return sortConfig.direction === 'asc' ? faSortUp : faSortDown;
        }
        return faSort;
    };

    const pageCount = Math.ceil(sortedData.length/pageLength);
    
    function selectRow(e, index) {
        if(!props.selected) return;
        if(selected === index){
            setSelected(-1);
        }else {
            setSelected(index);
            if(props.hasOwnProperty("selected"))
                props.selected(index, sortedData[index]);
        }
    }

    function setPageRender(e, i) {
        e.preventDefault();
        e.stopPropagation();
        setPage(Math.max(Math.min(i, pageCount-1), 0));
    }
    
    // Handle action button click - forwards the action to the parent component
    const handleActionButtonClick = (action, rowData) => {
        if (props.actionHandler) {
            props.actionHandler(action, rowData);
        }
    };

    return(
        <>
            <Row style={{ borderBottom: "3px solid #0c6efd", margin: "5px" }}>
                {columnData.map((obj, index) => {
                    return obj.type !== TableDataTypes.hidden ? (
                        <Col key={index} xs={obj.size}>
                            <h6 
                                style={{ 
                                    display: 'flex', 
                                    alignItems: 'center',
                                    cursor: obj.sortable !== false ? 'pointer' : 'default'
                                }}
                                onClick={() => requestSort(index)}
                            >
                                {obj.name}
                                {obj.sortable !== false && (
                                    <FontAwesomeIcon 
                                        icon={getSortIcon(index)} 
                                        style={{ marginLeft: '5px', opacity: sortConfig.key === index ? 1 : 0.3 }} 
                                    />
                                )}
                            </h6>
                        </Col>
                    ) : null;
                })}
            </Row>
            <Row style={{margin: "5px"}}>
                {sortedData.slice(page * pageLength, (page * pageLength) + pageLength).map((row, index) => {
                    let realdex = sortedData.indexOf(row);
                    return (
                        <Card
                            className="mb-1"
                            onClick={(e) => selectRow(e, realdex)}
                            bg={realdex === selected ? "primary" : ""}
                            text={realdex === selected ? "light" : ""}
                            key={index}
                        >
                            <Row style={{ height: "50px" }}>
                                {row.map((rowCol, indexCol) => {
                                    if (columnData[indexCol].type === TableDataTypes.hidden) {
                                        return null;
                                    }
                                    
                                    // Special handling for button type with action
                                    if (columnData[indexCol].type === TableDataTypes.button) {
                                        // Check if this is our pencil edit button
                                        if (columnData[indexCol].props && columnData[indexCol].props.icon === "pencil") {
                                            const buttonProps = {
                                                ...columnData[indexCol].props,
                                                onClick: handleActionButtonClick,
                                                children: row // Pass the entire row for reference
                                            };
                                            return (
                                                <Col key={indexCol} className="align-self-center" xs={columnData[indexCol].size}>
                                                    {React.createElement(TableDataTypes.button, buttonProps)}
                                                </Col>
                                            );
                                        }
                                        // Use original behavior for regular buttons with icon arrays
                                        return (
                                            <Col key={indexCol} className="align-self-center" xs={columnData[indexCol].size}>
                                                {React.createElement(columnData[indexCol].type, columnData[indexCol].props, rowCol)}
                                            </Col>
                                        );
                                    }
                                    
                                    // Normal column rendering
                                    return (
                                        <Col key={indexCol} className="align-self-center" xs={columnData[indexCol].size}>
                                            {React.createElement(columnData[indexCol].type, columnData[indexCol].props, rowCol)}
                                        </Col>
                                    );
                                })}
                            </Row>
                        </Card>
                    );
                })}
            </Row>
            <Row style={{borderTop: "3px solid #0c6efd", margin: "5px"}}>
                <Col className="align-content-center">
                    <div className="text-center"><small style={{marginRight: "20px"}}>Total: {sortedData.length}</small>
                        <Badge onClick={(e)=> setPageRender(e,0)} bg="secondary"><FontAwesomeIcon icon={faAnglesLeft} /></Badge>
                        <Badge onClick={(e)=> setPageRender(e,page-1)} bg="secondary"><FontAwesomeIcon icon={faAngleLeft} /></Badge>
                        <small> {page+1} of {pageCount} </small>
                        <Badge onClick={(e)=> setPageRender(e,page+1)} bg="secondary"><FontAwesomeIcon icon={faAngleRight} /></Badge>
                        <Badge onClick={(e)=> setPageRender(e,pageCount)} bg="secondary"><FontAwesomeIcon icon={faAnglesRight} /></Badge>
                    </div>
                </Col>
            </Row>
        </>
    )
}

export default TableList;